import type { TrainingClassSession } from '../../types';
import { H4, Stack } from '@workramp/ui';
import { isRichTextContentEmpty } from '~/features/rich-text-editor';
import DocumentObjectTextarea from '~/components/document/objects/document_object_textarea';
import { I18n } from '~/common/explicit-exports';

type Props = {
  session: TrainingClassSession;
  registered: boolean;
};

const TRANSLATED_SESSION_DETAILS = I18n.t('js.learner.events.sessions.session_details');

export const WebinarDetails = ({ session, registered }: Props) => {
  if (!registered || isRichTextContentEmpty(session.webinarDescription)) {
    return null;
  }

  return (
    <Stack size={2}>
      <H4 size={1}>{TRANSLATED_SESSION_DETAILS}</H4>
      <DocumentObjectTextarea html={session.webinarDescription} />
    </Stack>
  );
};
